import SharedToolbar, { type SharedToolbarProps } from "../SharedToolbar";

export type { ColumnDetails, ColumnDetailsMap, ColumnLabel } from "../toolbarTypes";

interface Props extends Omit<SharedToolbarProps, "createLabelKey" | "handleCreate"> {
  openModal?: (open: boolean) => void;
}

const Toolbar = ({ openModal, ...props }: Props) => (
  <SharedToolbar {...props} createLabelKey="expense.toolbar.newExpense" handleCreate={() => openModal?.(true)} />
);

export default Toolbar;
